import axios from 'axios';
import * as jsonpatch from 'fast-json-patch';
import { FilterChangelogPatch } from '../shared/field_inputs/HelpMethods';

const CancelToken = axios.CancelToken;
let cancel;

export async function HandleAddOrganization(organization) {
    const url = 'api/crmOrganizationFront/addOrganization/';

    const res = await axios.post(url, organization).then(
        (response) => {
            if (response.status === 200) {
                return { success: true, error: null, data: response.data };
            } else {
                return { success: false, error: response.data.message, data: null };
            }
        },
        (error) => {
            return { success: false, error: 'Det gick inte att spara ändringen, vänligen kontakta alltid@consid.se.', data: null };
        }
    );

    return res;
}

export async function HandlePatchOrganization(initialOrganization, newOrganization) {
    const patch = jsonpatch.compare(initialOrganization, newOrganization);
    let changelogPatch = [];

    patch.forEach((operation) => {
        operation.oldValue = jsonpatch.getValueByPointer(initialOrganization, operation.path);
    });

    changelogPatch = FilterChangelogPatch(patch);

    const url = 'api/crmOrganizationFront/patchOrganization/';
    const body = {
        entityId: initialOrganization.id,
        serializedPatch: JSON.stringify(patch),
        serializedChangelogPatch: JSON.stringify(changelogPatch),
    };

    const response = await axios.put(url, body).then(
        (response) => {
            if (response.status === 200) {
                return { success: true, error: null, organization: response.data };
            } else {
                return { success: false, error: response.data.message, organization: null };
            }
        },
        (error) => {
            return { success: false, error: 'Det gick inte att spara ändringen, vänligen kontakta alltid@consid.se.', data: null };
        }
    );

    return response;
}

export async function HandleDeleteOrganization(organizationId) {
    const url = 'api/crmOrganizationFront/deleteOrganization/';
    const query = { organizationId: organizationId };

    const response = await axios.delete(url, { params: query }).then(
        (response) => {
            if (response.status === 200) {
                return { success: true, error: null, deal: response.data };
            } else {
                return {
                    success: false,
                    error: response.data.message,
                    deal: null,
                };
            }
        },
        (error) => {
            return {
                success: false,
                error: 'Det gick inte att spara ändringen, vänligen kontakta alltid@consid.se.',
                deal: null,
            };
        }
    );
    return response;
}

export async function GetOrganizationHistory(organizationId, callback) {
    cancel && cancel();

    const uri = `api/crmOrganizationFront/getOrganizationHistory/`;
    const params = {
        organizationId,
    };

    try {
        axios
            .get(uri, {
                params,
                //cancelToken: new CancelToken((c) => {
                //    cancel = c;
                //}),
                headers: {
                    Accept: 'application/json, text/plain, */*',
                    'Content-Type': 'application/json;charset=UTF-8',
                },
            })
            .then((response) => {
                return callback({ success: true, data: response.data });
            })
            .catch((thrown) => {
                if (axios.isCancel(thrown)) {
                } else {
                }

                return callback({ success: false });
            });
    } catch (error) {
        console.error(error);
        return callback({ success: false });
    }
}

export async function GetOrganizationPersons(organizationId, callback) {
    cancel && cancel();

    const uri = `api/crmOrganizationFront/organizationPersons/`;
    const params = {
        organizationId,
    };

    try {
        axios
            .get(uri, {
                params,
                cancelToken: new CancelToken((c) => {
                    cancel = c;
                }),
                headers: {
                    Accept: 'application/json, text/plain, */*',
                    'Content-Type': 'application/json;charset=UTF-8',
                },
            })
            .then((response) => {
                return callback({ success: true, data: response.data });
            })
            .catch((thrown) => {
                if (axios.isCancel(thrown)) {
                } else {
                }

                return callback({ success: false });
            });
    } catch (error) {
        console.error(error);
        return callback({ success: false });
    }
}

export async function GetActiveOrganization(organizationId, callback) {
    cancel && cancel();

    const uri = `api/crmOrganizationFront/getOrganization`;
    const params = {
        organizationId,
    };

    try {
        axios
            .get(uri, {
                params,
                //cancelToken: new CancelToken((c) => {
                //    cancel = c;
                //}),
                headers: {
                    Accept: 'application/json, text/plain, */*',
                    'Content-Type': 'application/json;charset=UTF-8',
                },
            })
            .then((response) => {
                return callback({ success: true, data: response.data });
            })
            .catch((thrown) => {
                if (axios.isCancel(thrown)) {
                } else {
                }

                return callback({ success: false, data: null });
            });
    } catch (error) {
        return callback({ success: false, data: null });
    }
}

//export async function HandleDeletePerson(person) {
//    async function DeletePerson() {
//        const url = 'api/crmPerson/deletePerson/';
//        const body = { person };
//
//        let res = await axios.post(url, body).then(
//            (response) => {
//                if (response.data.success) {
//                    return { success: true, error: null, data: response.data };
//                } else {
//                    return { success: false, error: response.data.message, data: null };
//                }
//            },
//            (error) => {
//                return { success: false, error: 'Det gick inte att spara ändringen, vänligen kontakta alltid@consid.se.', data: null };
//            }
//        );
//
//        return res;
//    }
//
//    return await DeletePerson();
//}
